import { Avatar } from '@cian/ui-kit/avatar';
import { UIHeading4 } from '@cian/ui-kit/typography';
import * as React from 'react';

import * as styles from './Branding.css';
import { IAuthor } from '../../../../../common/repositories/dailyrent/entities/author/Author';

export const Branding = (props: Pick<IAuthor, 'avatar' | 'id' | 'displayName'>) => {
  const { id, avatar, displayName } = props;

  return (
    <div className={styles['branding-container']}>
      <div className={styles['branding-avatar']}>
        <Avatar type="agency" size={40} src={avatar} />
      </div>
      <div className={styles['branding-content']}>
        <UIHeading4>{displayName || id}</UIHeading4>
      </div>
    </div>
  );
};
